import State from "ducks/state"
import {breakpoints} from "@next/ux-fabric"
import {connect} from "react-redux"
import {getFullHeaderHeight} from "../../utils/getHeaderHeight"
import {shouldDisplayBackToSiteBanner} from "../../utils/backToSiteBanner"
import {ENTRYPOINT_HEADER_NAME} from "../../config/constants"
import {SupportedRegionTypes} from "../../models/regions"
import checkBannerVisibility from "../../utils/checkBannerVisibility"

export const mapStateToProps = (state: State) => {
    const {
        template,
        showStaticHeaderBanner,
        enableContentBanner,
        isCountrySelectorInGlobalAppBar,
        backToNextBannerShowAlways,
    } = state.settings

    const showBackToSiteBanner = shouldDisplayBackToSiteBanner(
        state.data?.regions,
        state.settings.backToSiteBannerConfiguration,
        state.request.headers?.[ENTRYPOINT_HEADER_NAME],
        backToNextBannerShowAlways,
    )

    const messageBannerControls: any = state.data?.regions.find(
        region => region.type === SupportedRegionTypes.MessageBanner,
    )

    const bannerVisibility = checkBannerVisibility(
        state.data?.regions.find(region => region.type === SupportedRegionTypes.StaticBannerLinks)?.elements,
        enableContentBanner,
        state.request.url,
        messageBannerControls?.enabled,
        showStaticHeaderBanner,
        (typeof window !== "undefined" && window.innerWidth > breakpoints.values.md) || true, // Default to true for SSR
        isCountrySelectorInGlobalAppBar,
    )
    const headerHeights = getFullHeaderHeight(
        template,
        bannerVisibility.showaAppBar,
        bannerVisibility.showCMSBanner,
        showBackToSiteBanner,
        false,
    )

    return {
        mobileHeight: headerHeights.mobile,
        desktopHeight: headerHeights.desktop,
    }
}

export default connect(mapStateToProps)
